'use strict';

angular.module('shiftTraderApp')
  .directive('saShiftOverlapBar', ['$compile', 'TimeService', function ($compile, TimeService) {
      var getBlockTemplate = function(styles, additionalClasses, twx) {
        if (_.isUndefined(additionalClasses)) {
          additionalClasses = [];
        }
        return '<div class="shift_overlap_block ' + additionalClasses.join(' ') + '" style="left:' + styles.left + ';width:' + styles.width + ';">' +
        '<div class="block_text">' + (twx ? TimeService.minimalTwixFormat(twx, true, true) : '') +
        '</div>' +
        '</div>';
      };

      var baseTemplate = '<div class="sa_shift_overlap_bar">' +
        '<div class="last_week_work_periods"></div>' +
        '<div class="current_shift_container"></div>' +
        '</div>';

      return {
        restrict: 'EA',
        template: baseTemplate,
        scope: {
          shift: '=',
          workPeriods: '='
        },
        link: function postLink(scope, element) {
          scope.currentStartDateTwix = TimeService.getDayTwixFromDate(scope.shift.start_time);
          scope.currentEndDateTwix = TimeService.getDayTwixFromDate(scope.shift.end_time);


          var calculateBarPosition = function(obj) {
            var left = (obj.start_time.hours() * 60 + obj.start_time.minutes()) / 1440.0 * 100;
            var width = obj.start_time.twix(obj.end_time).length('minutes') / 1440.0 * 100;

            // case where obj starts before the reference day
            if ((obj.range_twix.start.day() < scope.currentStartDateTwix.start.day()) ||
              (obj.range_twix.start.day() === 6 && scope.currentStartDateTwix.start.day() === 0)) {
              left = 0;
              width = (obj.range_twix.end.hours() * 60 + obj.range_twix.end.minutes()) / 1440.0 * 100;
            }

            // case where object ends after reference day
            if ((obj.range_twix.end.day() > scope.currentStartDateTwix.start.day()) ||
              (obj.range_twix.end.day() === 0 && scope.currentStartDateTwix.start.day() === 6)) {
              width = (1440 - (obj.range_twix.start.hours() * 60 + obj.range_twix.start.minutes())) / 1440 * 100;
            }

            return {
              left: left + '%',
              width: width + '%'
            };
          };

          var render = function() {
            // loop over workPeriods, rendering to rear layer
            var lastWeekWorkPeriodsContainer = element.find('.last_week_work_periods');
            lastWeekWorkPeriodsContainer.empty();

            var currentShiftContainer = element.find('.current_shift_container');
            currentShiftContainer.empty();

            var shiftShiftedLastWeekStart = moment(scope.currentStartDateTwix.start).subtract(1, 'week');
            var shiftShiftedLastWeekEnd = moment(scope.currentStartDateTwix.end).subtract(1, 'week');
            var dayRange = shiftShiftedLastWeekStart.twix(shiftShiftedLastWeekEnd);
            //console.log('dayRange', dayRange.format());

            // need to narrow it down to only workPeriods that overlap with this shift's start_time date
            //console.log('workPeriods', scope.workPeriods);
            var filteredWorkPeriods = _.where(scope.workPeriods, function(wp) {
              return wp.range_twix.overlaps(dayRange) &&
                Math.abs(wp.range_twix.intersection(dayRange).length('minutes')) > 0;
            });
            //console.log('filteredWorkPeriods', filteredWorkPeriods);
            _.each(filteredWorkPeriods, function(wp) {
              var pos = calculateBarPosition(wp);
              //console.log('wp added: ', wp.id, wp.range_twix.format(), pos.left, pos.width);
              lastWeekWorkPeriodsContainer.append($compile(getBlockTemplate(pos, [], wp.range_twix))(scope));
            });

            if (scope.shift) {
              currentShiftContainer.append($compile(getBlockTemplate(calculateBarPosition(scope.shift), ['current_shift']))(scope));
            }
          };
          render();

          scope.$watch(function() {
            return (scope.shift && scope.shift.id) + '-' + (scope.workPeriods && scope.workPeriods.length > 0 && _.pluck(scope.workPeriods, 'id').join(','));
          }, function(newVal, oldVal) {
            if (newVal !== oldVal) {
              render();
            }
          });

        }
      };
  }]);
